<div class="data-card">
  <div class="data-card__header">
    <span class="data-card__header__title" *ngIf="!isLoading"> {{ title }}</span>
    <mat-icon
      class="data-card__header__help-tooltip material-icons-outlined"
      *ngIf="!isLoading && helpTooltip"
      [matTooltip]="helpTooltip"
      >info</mat-icon
    >
    <ngx-skeleton-loader
      class="data-card__header__title"
      [theme]="{ height: '18px', width: '100px' }"
      *ngIf="isLoading"
    ></ngx-skeleton-loader>
  </div>

  <div class="data-card__body">
    <div class="data-card__body__column">
      <div class="data-card__body__data" [ngStyle]="{ color: color }" [matTooltip]="tooltipData">
        <span class="number" *ngIf="!isLoading && !isChart">
          {{ data }}
        </span>

        <ngx-skeleton-loader
          *ngIf="isLoading"
          class="number"
          [theme]="{
            height: isChart ? '117px' : '49px',
            width: isChart ? '200px' : '120px',
            margin: '0'
          }"
        ></ngx-skeleton-loader>

        <span class="text" *ngIf="measurement && !isChart">
          {{ measurement }}
        </span>

        <ng-content *ngIf="!isLoading && isChart" select="[slot='chart']"></ng-content>
      </div>

      <span class="data-card__body__label" *ngIf="label">
        {{ label }}
      </span>
    </div>
  </div>

  <div class="data-card__footer" [class.hidden]="hideFooter">
    <ng-content></ng-content>
  </div>
</div>
